"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var focusManager = _interopRequireWildcard(require("../../util/focusManager"));

var _scopeTab = _interopRequireDefault(require("../../util/scopeTab"));

var _ActionRoot = require("../../higher-order/ActionRoot");

var _class, _class2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var ModalPortal = (_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalPortal, _React$Component);

  var _super = _createSuper(ModalPortal);

  function ModalPortal() {
    _classCallCheck(this, ModalPortal);

    return _super.apply(this, arguments);
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      focusManager.setupScopedFocus(_reactDom.default.findDOMNode(this));
      focusManager.markForFocusLater();
      this.refs.dialog.focus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      focusManager.returnFocus();
      focusManager.teardownScopedFocus();
    }
  }, {
    key: "close",
    value: function close() {
      if (this.props.onClose) {
        this.props.onClose();
      }

      this.context.dispatcher.emit("HIDE_MODAL", {
        modalKey: this.props.modalKey
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.keyCode === 9
      /*tab*/
      ) {
        (0, _scopeTab.default)(this.refs.dialog, e);
      }

      if (e.keyCode === 27
      /*esc*/
      ) {
        if (this.props.enableDefaultCloseButton) {
          this.close();
        }
      }
    }
  }, {
    key: "handleClickCloseButton",
    value: function handleClickCloseButton(e) {
      e.preventDefault();
      this.close();
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (this.props.shouldCloseOnOverlayClick) {
        e.stopPropagation();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        _react.default.createElement("div", {
          ref: "dialog",
          className: "modal-dialog " + (this.props.className || ""),
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          tabIndex: "-1",
          role: "dialog"
        }, !this.props.hideHeader && /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-header"
        }, this.props.title, this.props.enableDefaultCloseButton && /*#__PURE__*/_react.default.createElement("button", {
          className: "modal-close-button",
          title: "Close",
          onClick: this.handleClickCloseButton
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon-cancel-thin"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-content"
        }, this.props.children), this.props.showFooter && /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-footer"
        }, this.props.enableDefaultCloseButton && /*#__PURE__*/_react.default.createElement("button", {
          className: "modal-footer-close-button",
          onClick: this.handleClickCloseButton
        }, "Close")))
      );
    }
  }]);

  return ModalPortal;
}(_react.default.Component), _defineProperty(_class2, "propTypes", {
  modalKey: _propTypes.default.string.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,
  hideHeader: _propTypes.default.bool,
  allowScrollBar: _propTypes.default.bool,
  shouldCloseOnOverlayClick: _propTypes.default.bool,
  enableDefaultCloseButton: _propTypes.default.bool,
  className: _propTypes.default.string
}), _defineProperty(_class2, "defaultProps", {
  enableDefaultCloseButton: true
}), _defineProperty(_class2, "contextType", _ActionRoot.ActionRootContext), _class2), (_applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClickCloseButton", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleClickCloseButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype)), _class);
var _default = ModalPortal;
exports.default = _default;